import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexNonAxisChartSeries,
  ChartComponent,
} from 'ng-apexcharts';

import {
  ChartOptions,
  DashboardChartInput,
  DEFAULT_APEX_CHART,
  DEFAULT_APEX_OPTIONS,
} from '../common-apex';

@Component({
  selector: 'app-stacked-column-card',
  templateUrl: './stacked-column-card.component.html',
  styleUrls: ['./stacked-column-card.component.scss'],
})
export class StackedColumnCardComponent implements OnInit {
  @ViewChild(ChartComponent) chart: ChartComponent;
  @Input() data: DashboardChartInput;
  @Input() values: ApexAxisChartSeries | ApexNonAxisChartSeries;
  public chartOptions: Partial<ChartOptions>;

  constructor() {}

  ngOnInit() {
    if (this.data) {
      this.chartOptions = {
        ...DEFAULT_APEX_OPTIONS,
        title: this.data.title,
        // series: this.data.values,
        chart: {
          ...DEFAULT_APEX_CHART,
          type: 'bar',
          // height: 350,
          stacked: true,
          ...this.data.chart,
        },
        xaxis: this.data.xaxis,
        fill: {
          opacity: 1,
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'left',
        },
        yaxis: this.data.yaxis,
      };
    }
  }
}
